<template>
  <div>
    <Row>
      <Col span="12">
        <Form
          ref="form"
          :model="formItem"
          :rules="formRules"
          :label-width="120"
        >
          <form-header name="基本信息" label="版本基本信息"></form-header>
          <FormItem label="名称" prop="title">
            <Input
              v-model="formItem.versionName"
              placeholder="请输入名称"
            ></Input>
          </FormItem>
          <form-header name="权限规则" label="选择合理的权限"></form-header>
          <FormItem label="勾选管理权限">
            <Tree
              ref="ruleTree"
              :data="ruletree"
              children-key="child"
              show-checkbox
              style="margin-top: -8px"
            ></Tree>
          </FormItem>
          <button-box>
            <button-sub @click="handleSubmit" :loading="sloading"></button-sub>
            <button-back></button-back>
          </button-box>
        </Form>
      </Col>
    </Row>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  components: {},
  data() {
    return {
      index: 1,
      sloading: false,
      action: "add",
      mname: "mobileVersion",
      url: {
        add: "/admin/system/mobileVersion/add",
        edit: "/admin/system/mobileVersion/edit",
      },
      kv: "",
      formItem: {
        mobileFunctionMouldIds: [],
        versionName: "",
      },
      formRules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
      },
      ruletree: [],
    };
  },
  async created() {
    let query = this.$route.query;
    this.action = query.action;
    if (query.action === "add") {
      // 添加初始化
      let ll1 = await this.getRules(); // 获取管理权限树
      this.setTreeRule(ll1, []);
    } else if (query.action === "edit") {
      this.kv = query.kv;
      this.initData();
    } else {
      return $utils.toast.error("请求方式异常");
    }
  },
  methods: {
    async initData() {
      let id = this.kv;
      let res = await $utils.api.load(`/admin/system/mobileVersion/${id}`, {});
      if (res && res.data) {
        this.formItem = res.data;
        // console.log(res);

        let ll1 = await this.getRules(); // 获取管理权限树
        this.setTreeRule(ll1, res.data.mobileFunctionMouldIds);
      }
    },
    handleSubmit() {
      // 管理权限
      const rr = this.$refs.ruleTree.getCheckedAndIndeterminateNodes();
      let rules = [];
      for (let i = 0; i < rr.length; i++) {
        const item = rr[i];
        rules.push(item.id);
      }
      this.formItem.mobileFunctionMouldIds = rules;
      this.$refs.form.validate((valid) => {
        if (valid) {
          $form.handleSubmit(this);
        }
      });
    },
    async getRules() {
      // 通过pid查询权限规则树
      // 加载详情数据
      let res = await $utils.api.load(
        `/admin/system/sysMobileFunctionMould/tree`,
        {}
      );
      if (res) {
        if (res.data) {
          return res.data;
        }
      }
      return;
    },
    setTreeRule(tree, rules) {
      this._doRules(tree, rules);
      this.ruletree = tree;
    },
    _doRules(arr, rules) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        // 判断子节点
        if (item.child && item.child.length > 0) {
          this._doRules(item.child, rules);
        }
        // 判断自身选中
        if (item.id && _.indexOf(rules, item.id) >= 0) {
          arr[i]["checked"] = true;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
